import { render, staticRenderFns } from "./ElraReport8Hero.vue?vue&type=template&id=5d5fa411&scoped=true"
import script from "./ElraReport8Hero.vue?vue&type=script&lang=ts"
export * from "./ElraReport8Hero.vue?vue&type=script&lang=ts"
import style0 from "./ElraReport8Hero.vue?vue&type=style&index=0&id=5d5fa411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5fa411",
  null
  
)

export default component.exports